import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LoadingService } from '@shared/modules/loading';
import { AlertService } from '@shared/modules/alert';
import { FileRefQuery } from '@shared/queries';
import { FileRef, Filter, ParseObject } from '@shared/data';

import { EditFileComponent } from './../edit-file';

@Component({
  selector: 'file-browser',
  styles: [require('./file-browser.component.scss')],
  template: require('./file-browser.component.html')
})
export class FileBrowserComponent implements OnInit {
  public files: FileRef[];
  public error: Parse.Error;
  public isLoading: boolean;

  public parent: FileRef;
  public ckEditorFuncNum: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private modalService: NgbModal) {

  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.ckEditorFuncNum = params['CKEditorFuncNum'];
    });

    this.fetchFiles(true);
  }

  // ===============================================================================================
  // Actions
  // ===============================================================================================

  public onBack() {
    this.parent = this.parent.parent;
    this.fetchFiles(true);
  }

  public onDelete(event: Event, file: FileRef, index: number) {
    event.stopPropagation();

    this.alertService.showDeleteWarning().then(
      confirm => {
        if (confirm) {
          this.loadingService.continue();

          if (file.isDir) {
            this.deleteFolder(file, index);
          } else {
            this.deleteFile(file, index);
          }
        }
      }
    );
  }

  public onEdit(event: Event, file: FileRef) {
    event.stopPropagation();

    const modalRef = this.modalService.open(EditFileComponent, { size: 'lg' });

    let component: EditFileComponent = modalRef.componentInstance;

    component.file = file;

    modalRef.result.then(
      result => {
        this.fetchFiles();
      },
      error => 0
    );
  }

  public onFileSelect($event) {
    let reader = new FileReader();
    let file: File = event.srcElement['files'][0];

    reader.onload = (e) => {
      let fileRef = new FileRef();
      let data = e.target['result'];
      let promise: Parse.Promise<FileRef>;

      fileRef.setFile(file, data);
      fileRef.parent = this.parent;

      this.files.unshift(fileRef);

      fileRef.save().then(
        result => {
          this.fetchFiles();
        },
        error => {
          this.error = error;
        }
      )
    };

    reader.readAsDataURL(file);
  }

  public onNewFolder() {
    const modalRef = this.modalService.open(EditFileComponent, { size: 'lg' });

    let component: EditFileComponent = modalRef.componentInstance;
    let folder = new FileRef();

    folder.type = FileRef.TYPE_FOLDER;
    folder.parent = this.parent;

    component.file = folder;

    modalRef.result.then(
      result => {
        this.files.unshift(folder);
        this.fetchFiles();
      }
    );
  }

  public onClick(event: Event, file: FileRef) {
    if (file.isDir) {
      this.parent = file;
      this.fetchFiles(true);
    } else {
      window.dispatchEvent(new CustomEvent('selectFile', { detail: {id: file.id, url: file.url} }));
      window.opener.CKEDITOR.tools.callFunction( this.ckEditorFuncNum, file.url);
      window.close();
    }
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private fetchFiles(reload?: boolean): void {
    let query = new FileRefQuery()
      .descending(FileRef.CREATE_AT_KEY)
      .equalTo(FileRef.PARENT_KEY, this.parent);

    if (reload) {
      this.files = [];
    }

    this.isLoading = true;

    query.find().then(
      result => {
        this.loadingService.complete();
        this.files = result;
        this.isLoading = false;
      },
      error => {
        this.loadingService.complete();
        this.error = error;
        this.isLoading = false;
      }
    );
  }

  private deleteFolder(folder: FileRef, index: number) {
    let query = new FileRefQuery()
      .equalTo(FileRef.PARENT_KEY, folder);

    this.files.splice(index, 1);

    query.find().then(
      files => {
        ParseObject.destroyAll(_.concat(files, folder)).then(
          result => {
            this.fetchFiles();
          },
          error => {
            this.error = error;
          }
        )
      },
      error => {
        this.error = error;
      }
    )
  }

  private deleteFile(file: FileRef, index: number) {
    this.files.splice(index, 1);

    file.destroy().then(
      result => {
        this.fetchFiles();
      },
      error => {
        this.error = error;
      }
    )
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+file-manager/file-browser/file-browser.component.ts